<template>
  <v-container class="pa-4">
    <v-card class="pa-4">
      <v-toolbar color="#1565C0" dark>
        <v-toolbar-title class="text-center"
          >Transaction Receipt</v-toolbar-title
        >
        <v-toolbar-items>
          <v-btn @click="navigateToStatementPage">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-row class="mt-4 text-center">
        <v-col>
          <v-icon size="40" color="#005F83">mdi-store</v-icon>
          <h2 class="font-weight-bold">
            -{{ transferToAccountCollection.amount }} USD
          </h2>
          <p class="text-subtitle-1 text-uppercase">
            {{ transferToAccountCollection.ToCustomer?.name }}
          </p>
        </v-col>
      </v-row>

      <v-divider class="my-4"></v-divider>
      <v-row dense>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p>APV:</p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p class="text-right font-weight-bold">
            {{ transferToAccountCollection.apv }}
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p>From account:</p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p class="text-right font-weight-bold text-uppercase">
            {{ transferToAccountCollection.fromCustomer?.name }}
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p>Original amount:</p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p class="text-right font-weight-bold">
            {{ transferToAccountCollection.amount }} USD
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p>Purchase #:</p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p class="text-right font-weight-bold">
            {{ transferToAccountCollection.purchase }}
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p>Reference #:</p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p class="text-right font-weight-bold">
            {{ transferToAccountCollection.reference }}
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p>Seller:</p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p class="text-right font-weight-bold text-uppercase">
            {{ transferToAccountCollection.ToCustomer?.name }}
          </p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p>Transaction date:</p>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <p class="text-right font-weight-bold">
            {{ formatDate(transferToAccountCollection.tranferDate) }}
          </p>
        </v-col>
      </v-row>

      <v-divider class="my-4"></v-divider>

      <v-row class="text-center">
        <v-col>
          <v-btn color="#1565C0" class="mr-4" @click="shareLink()">
            <v-icon left>mdi-share-variant</v-icon> Share Receipt
          </v-btn>
          <v-btn color="#1565C0" @click="generatePDF">
            <v-icon left>mdi-download</v-icon> Download PDF
          </v-btn>
          <div ref="pdfContent" class="receipt hidden-pdf">
            <h2 class="title">Transaction Receipt</h2>
            <div class="amount">
              -{{ transferToAccountCollection.amount }} USD
            </div>
            <p class="demo">
              {{ transferToAccountCollection.ToCustomer?.name }}
            </p>
            <table>
              <tr>
                <td>APV:</td>
                <td>{{ transferToAccountCollection.apv }}</td>
              </tr>
              <tr>
                <td>From account:</td>
                <td>{{ transferToAccountCollection.fromCustomer?.name }}</td>
              </tr>
              <tr>
                <td>Original amount:</td>
                <td>{{ transferToAccountCollection.amount }} USD</td>
              </tr>
              <tr>
                <td>Purchase #:</td>
                <td>{{ transferToAccountCollection.purchase }}</td>
              </tr>
              <tr>
                <td>Reference #:</td>
                <td>{{ transferToAccountCollection.reference }}</td>
              </tr>
              <tr>
                <td>Seller:</td>
                <td>{{ transferToAccountCollection.ToCustomer?.name }}</td>
              </tr>
              <tr>
                <td>Transaction date:</td>
                <td>
                  {{ formatDate(transferToAccountCollection.tranferDate) }}
                </td>
              </tr>
            </table>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { formatDateTime } from "@/utils/formatNumber";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  props: { transferToAccountCollection: Object }, // Receiving data from parent
  name: "TransactionReceipt",
  data() {
    return {
      token: null,
    };
  },
  methods: {
    generatePDF() {
      const element = this.$refs.pdfContent;
      // Temporarily make the element visible for rendering
      element.style.visibility = "visible";

      this.$nextTick(() => {
        // Use html2canvas to capture the content and generate the PDF
        html2canvas(element, { scale: 2 }).then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF();
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
          pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
          pdf.save("TransactionReceipt.pdf");

          // Hide the content again after the PDF is generated
          element.style.visibility = "hidden";
        });
      });
    },

    navigateToStatementPage() {
      window.location.href = `/transfer-to-account`;
    },
    formatDate(date) {
      return formatDateTime(date);
    },
    async shareLink() {
      if (this.token !== null) {
        const shareData = {
          title: "Transfer Receipt",
          text: `From account ${this.transferToAccountCollection.fromCustomer?.name} Transfer of ${this.transferToAccountCollection.amount} USD to ${this.transferToAccountCollection.ToCustomer?.name}`,
        };
        try {
          await navigator.share(shareData);
        } catch (err) {
          console.log(err);
        }
      } else {
        this.$router.push({ path: "/sign-in" });
      }
    },
  },
  created() {
    this.token = localStorage.getItem("client_token");
  },
};
</script>

<style scoped>
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}

.receipt {
  width: 500px;
  padding: 20px;
  background: white;
  font-family: Arial, sans-serif;
  border: 1px solid #ccc;
}
.title {
  background-color: #3f51b5;
  color: white;
  padding: 10px;
  text-align: center;
}
.amount {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
}
.demo {
  text-align: center;
  margin-bottom: 20px;
}
table {
  width: 100%;
  margin-top: 10px;
}
td {
  padding: 4px 8px;
  font-size: 14px;
}

.hidden-pdf {
  position: absolute;
  top: -9999px;
  left: -9999px;
  visibility: hidden;
}
</style>
